module.exports = __webpack_public_path__ + "img/img3.607e9302.png";